import { render, staticRenderFns } from "./photoCard.vue?vue&type=template&id=310fb6c3&scoped=true"
import script from "./photoCard.vue?vue&type=script&lang=js"
export * from "./photoCard.vue?vue&type=script&lang=js"
import style0 from "./photoCard.vue?vue&type=style&index=0&id=310fb6c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310fb6c3",
  null
  
)

export default component.exports